import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UntilDestroy } from '@ngneat/until-destroy';

import { StaticMessage } from '@shared/enums';
import { Constants, getStaticMessage } from '@shared/utils';
import { ConfirmDialogComponent } from '..';

@UntilDestroy()
@Component({
  selector: 'app-online',
  templateUrl: './online.component.html',
  styleUrls: ['./online.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineComponent implements OnChanges {
  @Input({ required: true }) isAppOnlineRealState: boolean;
  @Input({ required: true }) isAppLockedInOffline: boolean;
  @Output() setAppLockedInOffline = new EventEmitter<boolean>();

  isOnline: boolean;
  isUserOptionOffline: boolean;

  // tooltip messages
  goOffline = $localize`:@@shared.online.attrGoOffline:Click to go offline`;
  offlineWithInternet = $localize`:@@shared.online.attrOfflineWithInternet:You are in offline mode with internet connection`;
  offlineWithNoInternet = $localize`:@@shared.online.attrOfflineWithNoInternet:You are in offline mode with no internet connection`;

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isAppOnlineRealState) {
      this.isOnline = changes.isAppOnlineRealState.currentValue;
    }

    if (changes.isAppLockedInOffline) {
      this.isUserOptionOffline = changes.isAppLockedInOffline.currentValue;
    }
  }

  onValueChange(event: MatSlideToggleChange): void {
    if (!this.isOnline) {
      this.dialog.open(ConfirmDialogComponent, {
        ...Constants.DialogOptions,
        data: {
          title: $localize`:@@shared.online.internetConnectionError:No Internet Connection`,
          message: $localize`:@@shared.online.txtInternetConnectionError:Unable to connect to server.`,
          buttonLabel: getStaticMessage(StaticMessage.OkButton),
          hideCancelButton: true,
        },
      });

      event.source.checked = false;

      return;
    }

    this.isUserOptionOffline = !this.isUserOptionOffline;
    this.setAppLockedInOffline.emit(this.isUserOptionOffline);
  }
}
